module.exports = __webpack_public_path__ + "static/comforters-7a8fc6429a930270ec96bc1fd77fd9e3.png";